export const STATIC_COLUMN_ENTRY_TYPE = 8255;
export const STATIC_COLUMN_ENTRY_NO = 8230;
export const STATIC_COLUMN_ENTRY_CODE = 8300;
export const STATIC_COLUMN_GUID = 8235;
export const STATIC_COLUMN_GROUPGID = 8330;
export const STATIC_COLUMN_CROSS = 8377;
export const STATIC_COLUMN_BREEDING_METHOD_ABBR = 8254;
export const STATIC_COLUMN_MALE_PARENT_GID = 8345;
export const STATIC_COLUMN_MALE_PARENT_NAME = 8346;
export const STATIC_COLUMN_FEMALE_PARENT_GID = 8342;
export const STATIC_COLUMN_FEMALE_PARENT_NAME = 8343;
export const STATIC_COLUMN_IMMEDIATE_SOURCE_NAME = 8378;
export const STATIC_COLUMN_GROUP_SOURCE_NAME = 8340;
export const STATIC_COLUMN_GID = 8240;
export const STATIC_COLUMN_DESIGNATION = 8250;
export const STATIC_COLUMN_SAMPLES = -2;
export const STATIC_COLUMN_AVAILABLE = -4;
export const STATIC_COLUMN_UNIT = -5;
export const STATIC_COLUMN_ACTIVE_LOT = -3;
export const STATIC_COLUMN_BREEDING_METHOD_NAME = -10000;
export const STATIC_COLUMN_BREEDING_METHOD_TYPE = -10001;
export const STATIC_COLUMN_BREEDING_LOCATION_NAME = -10002;
export const STATIC_COLUMN_GERMPLASM_DATE = 1709;
export const STATIC_COLUMN_SAMPLE_NAME = -12;
export const STATIC_COLUMN_SAMPLE_UUID = -13;
export const STATIC_COLUMN_SAMPLING_DATE = -14;
export const STATIC_COLUMN_SAMPLING_TAKEN_BY = -15;
export const STATIC_COLUMN_SAMPLE_ENTRY = -16;
export const STATIC_COLUMN_SAMPLE_NO = -17;
export const STATIC_COLUMN_PLATE_ID = -18;
export const STATIC_COLUMN_WELL = -19;
export const STATIC_COLUMN_LOT_STORAGE_LOCATION_ABBREVIATION = -10004;
export const STATIC_COLUMN_TRANSACTION_ID = -10005;
export const STATIC_COLUMN_STOCK_ID = -10006;
export const STATIC_COLUMN_CREATED_DATE = -10007;
export const STATIC_COLUMN_CREATED_BY_USERNAME = -10008;
export const STATIC_COLUMN_LOT_TRANSACTION_TYPE = -10009;
export const STATIC_COLUMN_LOT_TRANSACTION_STATUS = -10010;
export const STATIC_COLUMN_LOT_UNIT = -10011;
export const STATIC_COLUMN_LOT_AMOUNT = -10012;
export const STATIC_COLUMN_LOT_NOTES = -10013;
export const STATIC_COLUMN_OBS_UNIT_ID = 8201;
export const STATIC_COLUMN_TRIAL_INSTANCE = 8170;
export const STATIC_COLUMN_PLOT_NO = 8200;
export const STATIC_COLUMN_GROUP_ID = 1731;
export const STATIC_COLUMN_IMMEDIATE_SOURCE_GID = -6;
export const STATIC_COLUMN_GROUP_SOURCE_GID = -8;
export const STATIC_COLUMN_BREEDING_METHOD_PREFERRED_NAME = 1701;
export const STATIC_COLUMN_BREEDING_METHOD_ABBREVIATION = 1702;
export const STATIC_COLUMN_BREEDING_METHOD_GROUP = 1704;
export const STATIC_COLUMN_LOCATION_NAME = 2110;
export const STATIC_COLUMN_LOCATION_ABBREVIATION = 8189;
export const STATIC_COLUMN_REFERENCE = -11;
export const STATIC_COLUMN_FILES = -101;
export const STATIC_COLUMN_LINE_GID = 8836;
export const STATIC_COLUMN_TESTER_GID = 8839;

// NOTE: For the germplasm list table,
// The MALE_PARENT_GID, FEMALE_PARENT_GID, MALE_PARENT_NAME, FEMALE_PARENT_NAME columns
// use these termId instead:
export const STATIC_COLUMN_FEMALE_PARENT = 1723;
export const STATIC_COLUMN_MALE_PARENT = 1724;
export const STATIC_COLUMN_FGID = 1725;
export const STATIC_COLUMN_MGID = 1726;

// export const STATIC_COLUMN_STOCK_ID = -1727;

// Centralized mapping for special translated static column labels
export const STATIC_COLUMN_LABEL_KEYS: Record<number, string> = {
    [STATIC_COLUMN_GROUPGID]: 'static-columns.GROUPGID',
    [STATIC_COLUMN_CROSS]: 'static-columns.CROSS',
    [STATIC_COLUMN_BREEDING_METHOD_ABBR]: 'static-columns.BREEDING_METHOD_ABBR',
    [STATIC_COLUMN_MALE_PARENT_GID]: 'static-columns.MALE_PARENT_GID',
    [STATIC_COLUMN_MALE_PARENT_NAME]: 'static-columns.MALE_PARENT_NAME',
    [STATIC_COLUMN_FEMALE_PARENT_GID]: 'static-columns.FEMALE_PARENT_GID',
    [STATIC_COLUMN_FEMALE_PARENT_NAME]: 'static-columns.FEMALE_PARENT_NAME',
    [STATIC_COLUMN_IMMEDIATE_SOURCE_NAME]: 'static-columns.IMMEDIATE_SOURCE_NAME',
    [STATIC_COLUMN_GROUP_SOURCE_NAME]: 'static-columns.GROUP_SOURCE_NAME',
    [STATIC_COLUMN_DESIGNATION]: 'static-columns.DESIGNATION',
    [STATIC_COLUMN_AVAILABLE]: 'static-columns.AVAILABLE',
    [STATIC_COLUMN_UNIT]: 'static-columns.UNIT',
    [STATIC_COLUMN_ACTIVE_LOT]: 'static-columns.ACTIVE_LOT',
    [STATIC_COLUMN_BREEDING_METHOD_NAME]: 'static-columns.BREEDING_METHOD_NAME',
    [STATIC_COLUMN_BREEDING_METHOD_TYPE]: 'static-columns.BREEDING_METHOD_TYPE',
    [STATIC_COLUMN_BREEDING_LOCATION_NAME]: 'static-columns.BREEDING_LOCATION_NAME',
    [STATIC_COLUMN_GERMPLASM_DATE]: 'static-columns.GERMPLASM_DATE',
    [STATIC_COLUMN_SAMPLE_NAME]: 'static-columns.SAMPLE_NAME',
    [STATIC_COLUMN_SAMPLE_UUID]: 'static-columns.SAMPLE_UUID',
    [STATIC_COLUMN_SAMPLING_DATE]: 'static-columns.SAMPLING_DATE',
    [STATIC_COLUMN_SAMPLING_TAKEN_BY]: 'static-columns.SAMPLING_TAKEN_BY',
    [STATIC_COLUMN_SAMPLE_ENTRY]: 'static-columns.SAMPLE_ENTRY',
    [STATIC_COLUMN_SAMPLE_NO]: 'static-columns.SAMPLE_NO',
    [STATIC_COLUMN_PLATE_ID]: 'static-columns.PLATE_ID',
    [STATIC_COLUMN_WELL]: 'static-columns.WELL',

    [STATIC_COLUMN_TRANSACTION_ID]: 'static-columns.TRANSACTION_ID',
    [STATIC_COLUMN_STOCK_ID]: 'static-columns.STOCK_ID',
    [STATIC_COLUMN_CREATED_DATE]: 'static-columns.CREATED_DATE',
    [STATIC_COLUMN_CREATED_BY_USERNAME]: 'static-columns.CREATED_BY_USERNAME',
    [STATIC_COLUMN_LOT_TRANSACTION_TYPE]: 'static-columns.LOT_TRANSACTION_TYPE',
    [STATIC_COLUMN_LOT_TRANSACTION_STATUS]: 'static-columns.TRANSACTION_STATUS',
    [STATIC_COLUMN_LOT_UNIT]: 'static-columns.LOT_UNIT',
    [STATIC_COLUMN_LOT_AMOUNT]: 'static-columns.LOT_AMOUNT',
    [STATIC_COLUMN_LOT_NOTES]: 'static-columns.LOT_NOTES',

    [STATIC_COLUMN_GROUP_ID]: 'static-columns.GROUP_ID',
    [STATIC_COLUMN_IMMEDIATE_SOURCE_GID]: 'static-columns.IMMEDIATE_SOURCE_GID',
    [STATIC_COLUMN_GROUP_SOURCE_GID]: 'static-columns.GROUP_SOURCE_GID',
    [STATIC_COLUMN_BREEDING_METHOD_PREFERRED_NAME]: 'static-columns.BREEDING_METHOD_PREFERRED_NAME',
    [STATIC_COLUMN_BREEDING_METHOD_ABBREVIATION]: 'static-columns.BREEDING_METHOD_ABBREVIATION',
    [STATIC_COLUMN_BREEDING_METHOD_GROUP]: 'static-columns.BREEDING_METHOD_GROUP',
    [STATIC_COLUMN_LOCATION_NAME]: 'static-columns.LOCATION_NAME',
    [STATIC_COLUMN_LOCATION_ABBREVIATION]: 'static-columns.LOCATION_ABBREVIATION',
    [STATIC_COLUMN_REFERENCE]: 'static-columns.REFERENCE',
    [STATIC_COLUMN_SAMPLES]: 'static-columns.SAMPLES',
    [STATIC_COLUMN_FILES]: 'static-columns.FILES',

    [STATIC_COLUMN_MGID]: 'static-columns.MALE_PARENT_GID',
    [STATIC_COLUMN_MALE_PARENT]: 'static-columns.MALE_PARENT_NAME',
    [STATIC_COLUMN_FGID]: 'static-columns.FEMALE_PARENT_GID',
    [STATIC_COLUMN_FEMALE_PARENT]: 'static-columns.FEMALE_PARENT_NAME'
};

/**
 * Returns a translation key for a static column id when it has a special label,
 * otherwise returns null so the template can fall back to `column.displayName`.
 */
export function getStaticColumnLabelKey(columnId: number): string | null {
    return STATIC_COLUMN_LABEL_KEYS[columnId] ?? null;
}
